import { QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router'
import { SesionProvider } from './auth/SesionProvider'
import { AppShell } from './componentes/AppShell'
import { Agendamiento } from './paginas/Agendamiento'
import { Calendario } from './paginas/Calendario'
import { Conversaciones } from './paginas/Conversaciones'
import { Login } from './paginas/Login'
import { Logistica } from './paginas/Logistica'
import { Workflows } from './paginas/Workflows'
import { Gestion } from './paginas/Gestion'
import { Sistema } from './paginas/Sistema'
import { GrandesEmpresas } from './paginas/GrandesEmpresas'
import { Alertas } from './paginas/Alertas'
import { RutaProtegida } from './rutas/RutaProtegida'
import { ProveedorTema } from './tema/ProveedorTema'
import { ApiProvider, crearClienteConsultas } from './api/contexto'

// La politica de reintentos vive junto al cliente de API porque depende de
// `ErrorApi`; aqui solo se instancia una vez para toda la aplicacion.
const clienteConsultas = crearClienteConsultas()

export function App() {
  return (
    // El proveedor de tema envuelve a todo, y no solo al armazon: el login
    // tambien se pinta en el tema elegido, que es la primera pantalla que se ve.
    <ProveedorTema>
      <QueryClientProvider client={clienteConsultas}>
        <SesionProvider>
          <ApiProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route element={<RutaProtegida />}>
                  <Route
                    element={
                      <AppShell>
                        <Outlet />
                      </AppShell>
                    }
                  >
                    <Route path="/logistica" element={<Logistica />} />
                    {/* Bandeja unificada: clientes y leads en una pantalla con
                        filtros Tipo (Leads/Clientes) y Zona (Castellón/Valencia). */}
                    <Route path="/conversaciones" element={<Conversaciones />} />
                    {/* Rutas viejas: redirigen a la unificada con el filtro puesto. */}
                    <Route
                      path="/conversaciones/clientes"
                      element={<Navigate to="/conversaciones?tipo=clientes" replace />}
                    />
                    <Route
                      path="/conversaciones/leads"
                      element={<Navigate to="/conversaciones?tipo=leads" replace />}
                    />
                    <Route path="/avisos" element={<Navigate to="/gestion?tab=seguimiento" replace />} />
                    <Route path="/confirmar" element={<Navigate to="/gestion?tab=semana" replace />} />
                    <Route path="/incidencias" element={<Navigate to="/gestion?tab=incidencias" replace />} />
                    <Route path="/auditoria" element={<Navigate to="/sistema?tab=auditoria" replace />} />
                    <Route path="/recalculo" element={<Navigate to="/sistema?tab=recalculo" replace />} />
                    {/* Fusiones: Gestión (Confirmar+Avisos+Incidencias) y Sistema (Auditoría+Recálculo). */}
                    <Route path="/gestion" element={<Gestion />} />
                    <Route path="/sistema" element={<Sistema />} />
                    <Route path="/grandes-empresas" element={<GrandesEmpresas />} />
                    <Route path="/alertas" element={<Alertas />} />
                    <Route path="/agendamiento" element={<Agendamiento />} />
                    <Route path="/calendario" element={<Calendario />} />
                    <Route path="/workflows" element={<Workflows />} />
                  </Route>
                </Route>
                <Route path="*" element={<Navigate to="/logistica" replace />} />
              </Routes>
            </BrowserRouter>
          </ApiProvider>
        </SesionProvider>
      </QueryClientProvider>
    </ProveedorTema>
  )
}
